/**
 * As sete etapas do wizard.
 *
 * A numeração NÃO é decoração: a ordem carrega informação que o cliente precisa
 * — não dá para anexar documento de sócio antes de declarar o sócio, nem rever
 * antes de preencher. Por isso a espinha mostra as sete, com as que já passaram
 * e as que faltam, em vez de só uma barra de progresso.
 */

export interface Etapa {
  numero: number
  chave: string
  titulo: string
  /** Aparece na espinha; diz o que a etapa pede, para reduzir surpresa. */
  resumo: string
}

export const ETAPAS: readonly Etapa[] = [
  { numero: 1, chave: 'identificacao', titulo: 'Identificação', resumo: 'CNPJ e e-mail' },
  { numero: 2, chave: 'empresa', titulo: 'Empresa', resumo: 'Razão social e endereço' },
  { numero: 3, chave: 'contato', titulo: 'Contato', resumo: 'Telefone e WhatsApp' },
  { numero: 4, chave: 'socios', titulo: 'Quadro societário', resumo: 'Sócios e documentos pessoais' },
  { numero: 5, chave: 'documentos', titulo: 'Documentos', resumo: 'Contrato social, licenças, certificados' },
  { numero: 6, chave: 'aceites', titulo: 'Aceites', resumo: 'Política de devolução' },
  { numero: 7, chave: 'revisao', titulo: 'Revisão e envio', resumo: 'Conferir tudo antes de enviar' },
] as const

/** Todas as etapas estão implementadas. */
export const ULTIMA_DISPONIVEL = 7

export type SituacaoEtapa = 'concluida' | 'atual' | 'proxima' | 'indisponivel'

export function situacaoDa(etapa: Etapa, atual: number, alcancada: number): SituacaoEtapa {
  if (etapa.numero === atual) return 'atual'
  if (etapa.numero < atual) return 'concluida'
  if (etapa.numero > ULTIMA_DISPONIVEL) return 'indisponivel'
  return etapa.numero <= alcancada ? 'proxima' : 'indisponivel'
}
